<template>
  <div id="modalMotivoSolicitud" class="modal" tabindex="-1">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            <span>Motivo de rechazo</span>
          </h5>
          <div class="acciones-modal">
            <button
              type="button"
              class="btn btn-success"
              @click="clickGuardar()"
            >
              <font-awesome-icon v-if="!guardando" :icon="Icons.ACEPTAR" />
              <div
                v-else
                id="indicador-guardado"
                class="spinner-border"
                role="status"
              ></div>
            </button>
            <button
              type="button"
              class="btn-close"
              @click="clickCerrar()"
              aria-label="Close"
            ></button>
          </div>
        </div>
        <div class="modal-body">
          <div class="input-group mb-3">
            <textarea
              v-model="motivoRechazo"
              class="form-control"
              placeholder="Ingrese el motivo"
            ></textarea>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const bootstrap = require("bootstrap");
import { Icons as IconConstants } from "../../../constants";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

export default {
  components: { FontAwesomeIcon },
  data() {
    return {
      item: null,
      modal: null,
      token: "",
      motivoRechazo: "",
      guardando: false,
    };
  },
  computed: {
    Icons() {
      return IconConstants;
    },
    PuedeGuardar() {
      return this.archivoImagen != null;
    },
  },
  methods: {
    EventoAbrir() {
      this.modal.show();
    },
    EventoCerrar() {
      this.cerrar();
    },
    cerrar() {
      this.motivoRechazo = "";
      this.modal.hide();
    },
    clickCerrar() {
      this.cerrar();
    },
    clickGuardar() {
      this.$emit("cerrar", this.motivoRechazo);
      this.cerrar();
    },
  },
  mounted() {
    this.motivoRechazo = "";
    this.token = localStorage.getItem("token");
    const opcionesModal = {};
    this.modal = new bootstrap.Modal(
      document.getElementById("modalMotivoSolicitud"),
      opcionesModal
    );
  },
};
</script>
<style scoped>
#indicador-guardado {
  width: 16px;
  height: 16px;
}
label {
  width: 100%;
  text-align: left;
  font-size: 14px;
  margin-left: 5px;
  margin-bottom: 1px;
}
</style>